import * as React from 'react';
import { components } from 'react-select';

export const StandardDropdownOption = props => {
  const { children, } = props;
  const passedProps = {...props}

  return (
    <components.Option {...passedProps}>
      {children}
    </components.Option>
  );
};
